import React from "react";

import { transformViewDate } from "utils/date-utils";
import { getPersonFullName } from "utils/person";
import { IExamsTableRowData } from "../types";

import useStyles from "./styles";

interface IProps {
  rowData: IExamsTableRowData;
}

const RaceDayExamConclusion = (props: IProps) => {
  const {
    rowData: { raceDayExamConclusion, examCompletedBy, examCompletedOn }
  } = props;
  const classes = useStyles();

  const conclusionCreator = getPersonFullName(examCompletedBy, "%f %L");
  const conclusionDate = transformViewDate(
    examCompletedOn,
    null,
    "MM/dd/yyyy - h:mm a"
  );

  return (
    <>
      {Boolean(raceDayExamConclusion) && (
        <div className={classes.conclusionContainer}>
          <div className={classes.conclusionHeader}>
            {"Race Day Exam Conclusion - "}
            <span className={classes.margin}>{conclusionCreator}</span>
            <span className={classes.margin}>{conclusionDate}</span>
          </div>
          <div>{raceDayExamConclusion}</div>
        </div>
      )}
    </>
  );
};

export default React.memo(RaceDayExamConclusion);
